module.exports = __webpack_public_path__ + "img/tracteurrouge_on.206031d1.gif";